
//  For ClientsHome page and image from clientsimage
import thebrandlab1 from "./clientsimage/Brandlab1.png";
import thebrandlab2 from "./clientsimage/Brandlab2.png";
import thebrandlab3 from "./clientsimage/Brandlab3.png";
import thebrandlab4 from "./clientsimage/Brandlab4.png";
import thebrandlab5 from "./clientsimage/Brandlab5.png";
import CR1 from "./clientsimage/Community Reshtey1.png";
import CR2 from "./clientsimage/Community Reshtey2.png";
import CR3 from "./clientsimage/Community Reshtey3.png";
import devdepam1 from "./clientsimage/Devdepam1.png";
import devdepam2 from "./clientsimage/Devdepam2.png";
import devdepam3 from "./clientsimage/Devdepam3.png";
import ZEVAR1 from "./clientsimage/ZEVAR1.png";
import ZEVAR2 from "./clientsimage/ZEVAR2.png";
import SG1 from "./clientsimage/SarwaG1.png";
import SG2 from "./clientsimage/SarwaG2.png";
import SG3 from "./clientsimage/SarwaG3.png";
import PL1 from "./clientsimage/Parasroadlines1.png";
import PL2 from "./clientsimage/Parasroadlines2.png";
import CRANOIST1 from "./clientsimage/CRANOIST MHE PVT LTD1.png";
import CRANOIST2 from "./clientsimage/CRANOIST MHE PVT LTD2.png";
import Siddhart1 from "./clientsimage/Siddhart Indutries.png";
import Siddhart2 from "./clientsimage/Siddhart Indutries2.png";
import DDC1 from "./clientsimage/DDC1.png";
import DDC2 from "./clientsimage/DDC2.png";
import Santosh from "./clientsimage/Santosh Vidya Welfare Foundation1.png";
import Santosh2 from "./clientsimage/Santosh Vidya Welfare Foundation2.png";
import KPG1 from "./clientsimage/KP & Grandsons1.png";
import KPG2 from "./clientsimage/KP & Grandsons2.png";
import srenter from "./clientsimage/SR Enterprises (Transport Software).png";
import AL1 from "./clientsimage/AL KAREEM TARBIYAT1.png";
import AL2 from "./clientsimage/AL KAREEM TARBIYAT2.png";
import MVUNIFORM from "./clientsimage/MV UNIFORM.png";
import MVUNIFORM2 from "./clientsimage/MV UNIFORM2.png";
import MVUNIFORM3 from "./clientsimage/MV UNIFORM3.png";
import Priyanshi from "./clientsimage/Priyanshi Coal Feader Pvt. Ltd.png";
import NITlab from "./clientsimage/COGNEURO.png";
import NITlab2 from "./clientsimage/COGNEURO2.png";
import Grah1 from "./clientsimage/GRAHIVEDA1.png";
import Grah2 from "./clientsimage/GRAHIVEDA2.png";
import VERMAFABRICATION from "./clientsimage/VERMA FABRICATION.png";
import DK from "./clientsimage/DK RTO1.png";
import Algo1 from './clientsimage/AlgoTrader1.jpeg';
import Algo2 from './clientsimage/AlgoTrader2.jpeg';
import Algo3 from './clientsimage/AlgoTrader3.jpeg';
import Algo4 from './clientsimage/AlgoTrader4.jpeg';
import AD1 from "./clientsimage/A&D Design Studio.png";
import AD2 from "./clientsimage/A&D Design Studio2.png";
import AD3 from "./clientsimage/A&D Design Studio3.png";
import Reyanshi from "./clientsimage/Reyanshi.png";
import Reyanshi2 from "./clientsimage/Reyanshi2.png";
import AP from "./clientsimage/APSmarthomes.png"
import Rupesh from "./clientsimage/Rupesh Grahak Sewa.png";
import ShreeTalk from "./clientsimage/Shree Talk1.png";
import ShreeTalk2 from "./clientsimage/Shree Talk2.png";
import Dhyey from "./clientsimage/Dhyey Academy.png"


// For Clients page and image from clientLogoImage
import AL_KAREEM from "./clientLogoImage/AL KAREEM TARBIYAT.png";
import DK_RTO from "./clientLogoImage/DK RTO.png";
import CRANOIST_MHE from "./clientLogoImage/CRANOIST MHE PVT. LTD.png";
import MV_UNIFORM from "./clientLogoImage/MV UNIFORM.png";
import RUPESH_GRAHAK from "./clientLogoImage/Rupesh Grahak Seva Krndra.png";
import SHREE_TALK from "./clientLogoImage/SHREE TALK.png";
import VERMA_FABRICATION from "./clientLogoImage/VERMA FABRICATION.png";
import ZEVAR_ZARI from "./clientLogoImage/ZEVAR & ZARI.png";
import DDC_CONSULTANCY from "./clientLogoImage/DDC Consultancy.png";
import SR_ENTERPRISES from "./clientLogoImage/SR Enterprises (Transport Software).png";
import KP_GRANDSON from "./clientLogoImage/KP & GRANDSON ERP.png";
import Santosh_Vidya from "./clientLogoImage/Santosh Vidya Welfare Foundation.png";
import AD_DESIGN_STUDIO from "./clientLogoImage/A&D Design Studio.jpg";
import BRAND_LAB from "./clientLogoImage/THE BRAND LAB.png";
import RISHTEY from "./clientLogoImage/rishtey.jpg";
import DEVDEEPAM from "./clientLogoImage/devdeepam.png";
import SARWAGROUP from "./clientLogoImage/Sarwa Logo.png";
import PARASROADLINES from "./clientLogoImage/paras road lines.png";
import SIDDHARTHINDU from "./clientLogoImage/siddhart.webp";
import PRIYANSI from "./clientLogoImage/priyanshi.jpeg";
import NITLAB from "./clientLogoImage/nit lab.png";
import Grahveda from "./clientLogoImage/Grahveda.png";


// PlacedStudend section and also for Studentsreview
import s1 from "./PS_IMG/Aarya_pandey.jpeg";
import s2 from "./PS_IMG/Aditya_gandharwa.jpg";
import s3 from "./PS_IMG/Ankit_dewangan.jpg";
import s4 from "./PS_IMG/Ashirwad_sharma.jpg";
import s5 from "./PS_IMG/Bhawna_sahu.jpeg";
import s6 from "./PS_IMG/chandani_chaturvedi.jpeg";
import s7 from "./PS_IMG/Dev_nishad.jpg";
import s8 from "./PS_IMG/dipti_verma.jpg";
import s9 from "./PS_IMG/gajendra_nishad.jpg";
import s10 from "./PS_IMG/Himanshu_sahu.jpg";
import s11 from "./PS_IMG/jitendra_sahu.png";
import s12 from "./PS_IMG/kamini_sahu.jpg";
import s13 from "./PS_IMG/Kumkuk_nayak.jpg";
import s14 from "./PS_IMG/Lata_Dewangan.jpg";
import s15 from "./PS_IMG/namesh_dadsena.jpeg";
import s16 from "./PS_IMG/Pooja_rao.jpg";
import s17 from "./PS_IMG/pooja_yadav.jpg";
import s18 from "./PS_IMG/prerna_vinayak.jpg";
import s19 from "./PS_IMG/priya_mishra.jpg";
import s20 from "./PS_IMG/priyanshu_tripathi.jpg";
import s21 from "./PS_IMG/Richa_Tiwari.jpg";
import s22 from "./PS_IMG/Shalini_Choudhary.jpg";
import s23 from "./PS_IMG/Shruti_Sharm.jpg";
import s24 from "./PS_IMG/sujata.jpeg";
import s25 from "./PS_IMG/Poonam Sahu.png";
import s26 from "./PS_IMG/Shrithi Tiwari.png";
import s27 from "./PS_IMG/Durga_Sidar.jpeg";
import s28 from "./PS_IMG/Vasu_satya.jpeg"


// ClientsHome Page Portfolio section
export const projects = [
  {
    title: "THE BRAND LAB",
    images: [thebrandlab1, thebrandlab2, thebrandlab3, thebrandlab4, thebrandlab5],
    features: ["Outdoor Advertising", "Transit Media", "Electronic Media", "Social Media", "Printing Solutions", "ACP Work"],
    link: "https://thebrandlab.solutions/",
  },
  {
    title: "Community Reshatey",
    images: [CR1, CR2, CR3],
    features: ["Profile Matchmaking", "Community Directory", "Secure Communication", "Advanced Search Filters", "Successful Couples Stories", "Verified Profile"],
    link: "https://www.communityrishtey.in/",
  },
  {
    title: "Devdepam",
    images: [devdepam1, devdepam2, devdepam3],
    features: ["Solar Energy Solutions", "EPC Services", "Solar Panel Installation", "Inverter & Battery Systems", "Green Tech Energy Consulting", "Eco-Friendly Solutions"],
    link: "https://www.devdepam.com/",
  },
  {
    title: "ZEVAR & ZARI",
    images: [ZEVAR1, ZEVAR2],
    features: ["Timeless Necklace Collection", "Luxury Earrings Collection", "Designer Embroidered Dress", "Bridal Collection", "Ethnic Wear", "Premium Quality"],
    link: "https://zevarandzari.in/",
  },
  {
    title: "SARWA GROUP",
    images: [SG1, SG2, SG3],
    features: ["Healthcare", "Education", "Construction Materials", "Corporate Advisory", "Advertisment and marketing agency", "Job consultancy"],
    link: "https://sarwagroup.com/",
  },
  {
    title: "Paras Roadlines",
    images: [PL1, PL2],
    features: ["Logistics & Freight Forwarding", "Fleet Management Solutions", "Safe & On-Time Delivery", "Nationwide Transportation Services", "Project Logistics", "LR Forwording"],
    link: "https://parasroadlines.com/",
  },
  {
    title: "CRANOIST MHE PVT LTD",
    images: [CRANOIST1, CRANOIST2],
    features: ["Crane Design & Engineering", "Crane Installation & Commissioning", "Preventive Maintenance & Emergency Repairs", "Crane Modernization & Upgrades", "Inspection & Safety Compliance", "Spare Parts Supply"],
    link: "https://erp.cranoistmhe.com/",
  },
  {
    title: "Siddharth Industry",
    images: [Siddhart1, Siddhart2],
    features: [" transformer Repairing Service", " transformer Maintaining Service", "Enhancement of Transformers", "Reliable Service", "Timely Supply", "Instant Cost Estimates"],
    link: "https://erp.siddhartindustries.in/",
  },
  {
    title: "DDC Consultancy",
    images: [DDC1, DDC2],
    features: ["Document Management", "Tele Calling", "Consulting", "Non-voice Process", "Field Collection", "Set-up"],
    link: "https://ddcconsultancy.in/",
  },
  {
    title: "Santosh Vidya Welfare Foundation",
    images: [Santosh, Santosh2],
    features: ["Support Girl Child Education", "Healthcare & Medical Camps", "Society", "Animal Welfire", "Women Empowerment & Child Rights", "Environment & Sanitation"],
    link: "https://santoshvidyafoundation.org/",
  },
  {
    title: "KP & Grandsons ERP",
    images: [KPG1, KPG2],
    features: ["Manufacture of IBR & Non-IBR components", "Design Engineer", "Operation, Repairing & Maintenance Services", "Billing System", "RLA STUDIES", "Reports & Analytics",
    ],
    link: "https://kpgrandsons.com//",
  },
  {
    title: "SR Enterprises",
    images: [srenter],
    features: ["Trip Management", "Driver Management", "Expense Tracking", "Reports", "Vehicle Management", "Trip History"],
    link: "https://sr.yashvitech.com/",
  },
  {
    title: "AL KAREEM TARBIYAT",
    images: [AL1, AL2],
    features: ["Empowering Education", "Women Empowerment", "Support Healthcare", "Disaster Relief", "Food Donation", "community support."],
    link: "https://www.alkareemtarbiyat.org/",
  },
  {
    title: "MV UNIFORM",
    images: [MVUNIFORM, MVUNIFORM2, MVUNIFORM3],
    features: [" School Uniforms", "Corporate Uniforms", "Bulk Orders", "Quality Assurance", "Custom Uniform Design", "Comfortable & Durable Fabric"],
    link: "https://uniformsolutions.store/",
  },
  {
    title: "Priyanshi Coal Feader Pvt Ltd",
    images: [Priyanshi],
    features: [" Coal transportation and supply services", "Customer-centric service", "Reliable Service", "Timely Supply", "Quality Assurance", "Efficient Logistics Management"],
    link: "https://priyanshi.coalfeed.in/",
  },
  {
    title: "NIT Project",
    images: [NITlab, NITlab2],
    features: ["Neuroscience Research", "Biomedical Devices", "Healthcare Innovation", "Neurological Assessment Tools", "Medical Lab Reports", "Clinical Data Management"],
    link: "https://cogneuromed.com/",
  },
  {
    title: "GRAH VEDA",
    images: [Grah1, Grah2],
    features: ["Vastu Consultation", "Career, Business & Financial Astrology", "Planetary Guidance", "Health & Wellness Insights", "Property Guidance", "Client Satisfaction"],
    link: "https://grahiveda.com/",
  },
  {
    title: "VERMA FABRICATION",
    images: [VERMAFABRICATION],
    features: ["Aluminium-Component-Production", "Aluminium Structural Fabrication", "Steel Fabrication", "Custom Fabrication", "Precision Work", "Industrial Solutions"],
    link: "https://vf.yashvitech.com/",
  },
  {
    title: "DK RTO",
    images: [DK],
    features: [" RTO Services", "Vehicle Registration", "Driving License", "RC Transfer", "Vehicle Documentation", "RTO Assistance"],
    link: "https://dk.yashvitech.com/",
  },
  {
    title: "Algo Trader",
    images: [Algo1, Algo2, Algo3, Algo4],
    features: ["Automated Trading Strategies", "Market Data Analysis", "Real-Time Trade Execution", "Risk Management", "Strategy Backtesting", "Trading Performance Analytics"],
    link: "*",
  },
  {
    title: "A&D Design Studio",
    images: [AD1, AD2, AD3],
    features: ["Creative Designs", "Interior Design", "3D Visualization", "Quality Execution", "Space Planning", "Customized Design Solutions"],
    link: "https://ad-designstudio.in/",
  },
  {
    title: "REYANSHI TRADER",
    images: [Reyanshi, Reyanshi2],
    features: ["Wholesale Supplies", "Waterproofing Chemical", "Tile Adhesive", "Import & Export Goods", "Industrial Chemical", "Waterproofing Chemical"],
    link: "*",
  },
  {
    title: "AP Smarthomes",
    images: [AP],
    features: ["Smart Lighting & Control", "Automated Security Systems", "IoT Integration", "Energy Management Systems", "Smart Home Automation", "Remote Device Monitoring"],
    link: "*",
  },
  {
    title: "Rupesh Grahak Seva Kendra",
    images: [Rupesh],
    features: [" Digital Services", "Online Applications", "Government Services", "Bill Payments", "Document Assistance", "Fast & Convenient Services"],
    link: "https://www.rupeshgrahaksevakendra.com/",
  },
  {
    title: "Shree Talk",
    images: [ShreeTalk, ShreeTalk2],
    features: ["English Communication", " Business Communication", "Experienced Faculty", "Personalized Student Guidance", "Easy Learning Steps", "Mock Tests & Practice"],
    link: "https://shreetalk.in/",
  },
  {
    title: "DHYEY ACADEMY",
    images: [Dhyey],
    features: ["Competitive Exam Coaching", "Experienced Faculty", "Interactive Live Lectures", "Comprehensive Study Material", "Mock Tests & Practice", "Personalized Student Guidance"],
    link: "*",
  },
];


// Clients page Portfolio Section
export const CLIENTS = [
  {
    name: "The Brand Lab",
    initial: "BL",
    image: BRAND_LAB,
    url: "https://thebrandlab.solutions/",
  },
  {
    name: "Rishtey",
    initial: "CR",
    image: RISHTEY,
    url: "https://communityrishtey.in/",
  },
  {
    name: "Devdepam Solar",
    initial: "DS",
    image: DEVDEEPAM,
    url: "https://devdepam.com/",
  },
  {
    name: "Zevar & Zari",
    initial: "ZZ",
    image: ZEVAR_ZARI,
    url: "https://zevarandzari.in/",
  },
  {
    name: "Sarwagroup",
    initial: "SG",
    image: SARWAGROUP,
    url: "https://sarwagroup.com/",
  },
  {
    name: "Paras Roadlines",
    initial: "PR",
    image: PARASROADLINES,
    url: "https://parasroadlines.com/",
  },
  {
    name: "Cranoist MHE",
    initial: "CM",
    image: CRANOIST_MHE,
    url: "https://erp.cranoistmhe.com/",
  },
  {
    name: "Siddharth Industry",
    initial: "SI",
    image: SIDDHARTHINDU,
    url: "https://erp.siddhartindustries.in/",
  },
  {
    name: "DDC Consultancy",
    initial: "DC",
    image: DDC_CONSULTANCY,
    url: "https://ddcconsultancy.in/",
  },
  {
    name: "Santosh Vidya",
    initial: "SV",
    image: Santosh_Vidya,
    url: "https://santoshvidyafoundation.org/",
  },
  {
    name: "KP & Grandson",
    initial: "KG",
    image: KP_GRANDSON,
    url: "https://kpgrandsons.com/",
  },
  {
    name: "SR Enterprises",
    initial: "SE",
    image: SR_ENTERPRISES,
    url: "https://sr.yashvitech.com/",
  },
  {
    name: "Al Kareem Tarbiyat",
    initial: "AK",
    image: AL_KAREEM,
    url: "https://www.alkareemtarbiyat.org/",
  },
  {
    name: "MV Uniform",
    initial: "MU",
    image: MV_UNIFORM,
    url: "https://uniformsolutions.store/",
  },
  {
    name: "Priyanshi Coalfeed",
    initial: "PC",
    image: PRIYANSI,
    url: "https://priyanshi.coalfeed.in/",
  },
  {
    name: "NIT LAB",
    initial: "NL",
    image: NITLAB,
    url: "https://cogneuromed.com/",
  },
  {
    name: "GRAH VEDA",
    initial: "GV",
    image: Grahveda,
    url: "https://grahiveda.com/",
  },
  {
    name: "Verma Fabrication",
    initial: "VF",
    image: VERMA_FABRICATION,
    url: "https://vf.yashvitech.com/",
  },
  {
    name: "DK RTO",
    initial: "DK",
    image: DK_RTO,
    url: "https://dk.yashvitech.com/",
  },
  {
    name: "ALGO TRADER",
    initial: "AT",
    image: "ALGO TRADER",
    url: "*",
  },
  {
    name: "A&D Design Studio",
    initial: "AD",
    image: AD_DESIGN_STUDIO,
    url: "https://www.ad-designstudio.in/",
  },
  {
    name: "REYANSHI TRADER",
    initial: "RT",
    image: "REYANSHI TRADER",
    url: "*",
  },
  {
    name: "AP Smarthomes",
    initial: "AP",
    image: "AP Smarthomes",
    url: "*",
  },
  {
    name: "Rupesh Grahak",
    initial: "RG",
    image: RUPESH_GRAHAK,
    url: "https://www.rupeshgrahaksevakendra.com/",
  },
  {
    name: "Shree Talk",
    initial: "ST",
    image: SHREE_TALK,
    url: "https://shreetalk.in/",
  },
  {
    name: "DHYEY ACADEMY",
    initial: "DA",
    image: "DHYEY ACADEMY",
    url: "*",
  },
];


// Placed Students Section
export const allStudents = [
  { photo: s1, name: "Aarya Pandey", role: "Business System Developer" },
  { photo: s2, name: "Aditya Gandharwa", role: "React Developer" },
  { photo: s3, name: "Ankit Dewangan", role: "Full Stack Developer" },
  { photo: s4, name: "Ashirwad Sharma", role: "Frontend Developer" },
  { photo: s5, name: "Bhawna Sahu", role: "App Developer" },
  { photo: s6, name: "Chandani Chaturvedi", role: "Full Stack Developer" },
  { photo: s7, name: "Dev Nishad", role: "Frontend Developer" },
  { photo: s8, name: "Dipti Verma", role: "Full Stack (ERP)" },
  { photo: s9, name: "Gajendra Nishad", role: "Software Engineer" },
  { photo: s10, name: "Himanshu Sahu", role: "Full Stack Developer" },
  { photo: s11, name: "Jitendra Sahu", role: "Software Engineer" },
  { photo: s12, name: "Kamini Sahu", role: "Full Stack (PHP)" },
  { photo: s13, name: "Kumkuk Nayak", role: "Software Engineer (PHP)" },
  { photo: s14, name: "Lata Dewangan", role: "MERN Developer" },
  { photo: s15, name: "Namesh Dadsena", role: "Full Stack Developer" },
  { photo: s16, name: "Pooja Rao", role: "Frontend Developer" },
  { photo: s17, name: "Pooja Yadav", role: "Backend Developer" },
  { photo: s18, name: "Prerna Vinayak", role: "Full Stack (MERN) Developer" },
  { photo: s19, name: "Priya Mishra", role: "App Developer" },
  { photo: s20, name: "Priyanshu Tripathi", role: "Backend Developer" },
  { photo: s21, name: "Richa Tiwari", role: "Full Stack Developer" },
  { photo: s22, name: "Shalini Choudhary", role: "Full Stack (MERN) Developer" },
  { photo: s23, name: "Shruti Sharma", role: "Full Stack (ERP)" },
  { photo: s24, name: "Sujata", role: "Full Stack Developer" },
  { photo: s25, name: "Poonam Sahu", role: "Network Engineer" },
  { photo: s26, name: "Shristi Tiwari", role: "Full Stack Developer" },
  { photo: s27, name: "Durga Sidar", role: "Full Stack Developer" },
  { photo: s28, name: "Vasu Satya", role: "Operation & Growth Associate" },
];


// Students Review Section
export const reviews = [
  {
    photo: s1,
    name: "Aarya Pandey",
    role: "Business System Developer",
    review: "YashviTech helped me gain practical skills and confidence. The mentors were supportive throughout my learning journey.",
    rating: 5,
  },
  {
    photo: s5,
    name: "Bhawna Sahu",
    role: "App Developer",
    review: "Excellent training with live projects. The placement support was amazing and helped me start my IT career.",
    rating: 5,
  },
  {
    photo: s10,
    name: "Himanshu Sahu",
    role: "Full Stack Developer",
    review: "The MERN Stack training was industry-focused. I learned real development and interview preparation.",
    rating: 5,
  },
  {
    photo: s21,
    name: "Richa Tiwari",
    role: "Full Stack Developer",
    review: "Best learning experience with experienced mentors. Highly recommended for freshers looking for placements.",
    rating: 5,
  },
  {
    photo: s14,
    name: "Lata Dewangan",
    role: "MERN Developer",
    review: "The MERN Stack course was well-structured and included real-time projects that boosted my confidence.",
    rating: 5,
  },
  {
    photo: s24,
    name: "Sujata",
    role: "Full Stack Developer",
    review: "A wonderful learning experience with supportive mentors, practical projects, and excellent placement assistance.",
    rating: 5,
  },
  {
    photo: s15,
    name: "Namesh Dadsena",
    role: "Full Stack Developer",
    review: "The practical assignments and coding sessions made learning enjoyable and effective.",
    rating: 5,
  },
  {
    photo: s9,
    name: "Gajendra Nishad",
    role: "Software Engineer",
    review: "The guidance from mentors and regular coding practice helped me achieve my career goals.",
    rating: 5,
  },
  {
    photo: s2,
    name: "Aditya Gandharwa",
    role: "React Developer",
    review: "The React training was excellent. I gained confidence in building real-world web applications and improved my coding skills.",
    rating: 5,
  },
  {
    photo: s19,
    name: "Priya Mishra",
    role: "App Developer",
    review: "I learned mobile application development with practical examples and real projects.",
    rating: 5,
  },
];

//  For Services Section
// export const services = [
//   { icon: '🌐', accent: '#E8571A', bg: '#FDF0E8', title: 'Web Development', desc: 'Custom, responsive websites and web apps built with React, Next.js, and Node.js. Fast, secure, and SEO-ready.', tags: ['React', 'Next.js', 'Node.js', 'MySQL'] },
//   { icon: '📱', accent: '#2D7D46', bg: '#EAF5EE', title: 'Mobile App Development', desc: 'Cross-platform and native apps for Android & iOS with Flutter and React Native. Smooth performance, great UX.', tags: ['Flutter', 'React Native', 'iOS', 'Android'] },
//   { icon: '🛒', accent: '#E8571A', bg: '#FDF0E8', title: 'E-Commerce Solutions', desc: 'Complete online stores with secure payment gateways, smart inventory, and conversion-optimised shopping experiences.', tags: ['Shopify', 'WooCommerce', 'Razorpay'] },
//   { icon: '☁️', accent: '#2D7D46', bg: '#EAF5EE', title: 'Cloud & DevOps', desc: 'Reliable infrastructure on AWS, Azure & GCP. CI/CD pipelines, Docker, Kubernetes — scalability without complexity.', tags: ['AWS', 'Docker', 'Kubernetes', 'CI/CD'] },
//   { icon: '🎨', accent: '#E8571A', bg: '#FDF0E8', title: 'UI / UX Design', desc: 'Wireframes, interactive prototypes, and pixel-perfect design systems tested with real users before writing code.', tags: ['Figma', 'Wireframing', 'Prototyping'] },
//   { icon: '🔒', accent: '#2D7D46', bg: '#EAF5EE', title: 'Cyber Security', desc: 'Vulnerability assessments, penetration testing, and ISO-aligned security audits to protect your business and reputation.', tags: ['VAPT', 'Pen Testing', 'ISO 27001'] },
// ];

// techStack page 
export const techStack = [
  // Frontend
  { icon: '⚛️', name: 'React.js' },
  { icon: '▲', name: 'Next.js' },
  { icon: '🟨', name: 'JavaScript' },
  { icon: '📘', name: 'TypeScript' },
  { icon: '🌐', name: 'HTML5' },
  { icon: '🎨', name: 'CSS3' },
  { icon: '💨', name: 'Tailwind CSS' },
  { icon: '🅱️', name: 'Bootstrap' },
  { icon: '🔷', name: 'Material UI' },
  { icon: '🅰️', name: 'Angular' },
  { icon: '💚', name: 'Vue.js' },
  { icon: '🟢', name: 'Nuxt.js' },

  // Backend
  { icon: '🍃', name: 'Node.js' },
  { icon: '🚂', name: 'Express.js' },
  { icon: '🐍', name: 'Python' },
  { icon: '🌐', name: 'Django' },
  { icon: '⚡', name: 'FastAPI' },
  { icon: '☕', name: 'Java' },
  { icon: '🍃', name: 'Spring Boot' },
  { icon: '🐘', name: 'PHP' },
  { icon: '🔺', name: 'Laravel' },
  { icon: '💎', name: 'Ruby on Rails' },
  { icon: '🟣', name: 'C# / .NET' },

  // Databases
  { icon: '🗄️', name: 'MySQL' },
  { icon: '🐘', name: 'PostgreSQL' },
  { icon: '🍃', name: 'MongoDB' },
  { icon: '🔥', name: 'Firebase' },
  { icon: '⚡', name: 'Redis' },
  { icon: '🗃️', name: 'SQLite' },
  { icon: '🔶', name: 'Oracle' },
  { icon: '🟦', name: 'Microsoft SQL Server' },

  // API & Architecture
  { icon: '🔗', name: 'REST API' },
  { icon: '◈', name: 'GraphQL' },
  { icon: '🔌', name: 'WebSocket' },
  { icon: '🔐', name: 'OAuth 2.0' },
  { icon: '🎫', name: 'JWT' },

  // DevOps & Containers
  { icon: '🐳', name: 'Docker' },
  { icon: '☸️', name: 'Kubernetes' },
  { icon: '🔄', name: 'GitHub Actions' },
  { icon: '🦊', name: 'GitLab CI/CD' },
  { icon: '🏗️', name: 'Jenkins' },
  { icon: '🔧', name: 'Terraform' },
  { icon: '📦', name: 'Nginx' },

  // Cloud & Hosting
  { icon: '🌐', name: 'AWS' },
  { icon: '☁️', name: 'Microsoft Azure' },
  { icon: '🔵', name: 'Google Cloud' },
  { icon: '▲', name: 'Vercel' },
  { icon: '🟣', name: 'Heroku' },
  { icon: '🔥', name: 'Firebase Hosting' },

  // Version Control
  { icon: '🐙', name: 'Git' },
  { icon: '🐙', name: 'GitHub' },
  { icon: '🦊', name: 'GitLab' },
  { icon: '🟠', name: 'Bitbucket' },

  // Mobile Development
  { icon: '📱', name: 'Flutter' },
  { icon: '⚛️', name: 'React Native' },
  { icon: '🤖', name: 'Android' },
  { icon: '🍎', name: 'iOS' },

  // Testing
  { icon: '🧪', name: 'Jest' },
  { icon: '🧪', name: 'Cypress' },
  { icon: '🎭', name: 'Playwright' },
  { icon: '🔬', name: 'Postman' },

  // Design & UI
  { icon: '🎨', name: 'Figma' },
  { icon: '🖌️', name: 'Adobe XD' },

  // E-Commerce / CMS
  { icon: '🛒', name: 'Shopify' },
  { icon: '📝', name: 'WordPress' },
  { icon: '🛍️', name: 'WooCommerce' },
];


// export const whyFeatures = [
//   { icon: '⚡', title: 'Rapid Delivery', desc: 'Agile sprints keep you shipping. Working software in 2–4 weeks, not months.' },
//   { icon: '🛡️', title: 'Dedicated Support', desc: '24/7 post-launch monitoring, proactive maintenance, and same-day critical bug fixes.' },
//   { icon: '💬', title: 'Transparent Process', desc: 'Weekly demos, real-time updates, and milestone-based billing. Always know where your project stands.' },
//   { icon: '🎯', title: 'ROI-First Thinking', desc: 'Every technical decision is weighed against your business goals. We ask "does this grow revenue?" first.' },
// ];

//  processSteps
// export const processSteps = [
//   { title: 'Discover', desc: 'Deep-dive into your goals and competitive landscape to build a crystal-clear project brief.' },
//   { title: 'Design', desc: 'Wireframes and prototypes validated with real users before writing a single line of code.' },
//   { title: 'Build', desc: 'Agile 2-week sprints with working demos and your feedback incorporated in real time.' },
//   { title: 'Launch', desc: 'Zero-downtime deployment, 30-day hypercare support, then seamless handover to your team.' },
// ];


// export const portfolio = [
//   { gradient: 'linear-gradient(135deg,#1e3a8a,#3b82f6)', icon: '🏪', type: 'E-Commerce', title: 'RetailPro', desc: '50K+ SKUs, AI recommendations & multi-currency checkout. Revenue up 180% in 3 months.' },
//   { gradient: 'linear-gradient(135deg,#1a4731,#2D7D46)', icon: '🏥', type: 'Healthcare', title: 'MediConnect', desc: 'Patient management with real-time doctor-patient video and smart appointment scheduling.' },
//   { gradient: 'linear-gradient(135deg,#7c1d1d,#E8571A)', icon: '📊', type: 'FinTech', title: 'WealthDash', desc: 'Live market analytics with portfolio tracking, AI alerts, and one-click tax reporting.' },
//   { gradient: 'linear-gradient(135deg,#1e3a8a,#0ea5e9)', icon: '🎓', type: 'EdTech', title: 'LearnHub LMS', desc: 'Video courses, gamified quizzes, and certificates trusted by 12,000+ learners.' },
//   { gradient: 'linear-gradient(135deg,#1a4731,#10b981)', icon: '🚚', type: 'Logistics', title: 'FleetTrack', desc: 'Real-time GPS fleet management with ML route optimisation — 22% fuel savings on day one.' },
//   { gradient: 'linear-gradient(135deg,#4a1942,#9333ea)', icon: '🏨', type: 'Hospitality', title: 'StayEasy', desc: 'Hotel booking engine with dynamic pricing, OTA sync, and a front-desk dashboard managers love.' },
// ];

// export const testimonials = [
//   { stars: 5, text: 'YashviTech rebuilt our entire e-commerce platform in 8 weeks. The attention to detail was extraordinary — our conversion rate jumped 2.3× and the team felt like an extension of ours throughout the entire project.', name: 'Rajesh Agarwal', role: 'CEO', company: 'FashionKart India', sector: 'E-Commerce Sector', initials: 'RA', color: '#E8571A' },
//   { stars: 5, text: 'They delivered a hospital management app that our doctors actually enjoy using. Post-launch support was seamless. I have recommended YashviTech to three other hospital groups already — outstanding work.', name: 'Dr. Priya Sharma', role: 'Director', company: 'MediCare Hospitals', sector: 'Healthcare Sector', initials: 'PS', color: '#2D7D46' },
//   { stars: 5, text: "The cloud migration cut our infrastructure bill by 40% and tripled our uptime. What impressed me most was how the team explained every decision in plain language — no jargon, just clarity and results.", name: 'Amit Verma', role: 'CTO', company: 'LogiTech Solutions', sector: 'Logistics Sector', initials: 'AV', color: '#1A2235' },
// ];

// contactDetails
export const contactDetails = [
  { icon: '📍', label: 'Office', value: '2nd Floor, Sahu Complex, near Disha College, Ramnagar Kota, Raipur, Chhattisgarh 492001' },
  { icon: '✉️', label: 'Email', value: 'info.yashvitech@gmail.com' },
  { icon: '📞', label: 'Phone', value: '+91 86400-91593' },
  { icon: '🕐', label: 'Working Hours', value: 'Mon – Sat, 9 AM – 6 PM' },
];

